export const getUnitByValue = (category: string, value: string) => {
  const categoryUnits = unitsByCategory[category as keyof typeof unitsByCategory];
  return categoryUnits?.find(unit => unit.value === value);
};

export const unitsByCategory: Record<string, Array<{ value: string; label: string }>> = {
  length: [
    { value: 'kilometer', label: 'Kilometers' },
    { value: 'meter', label: 'Meters' },
    { value: 'centimeter', label: 'Centimeters' },
    { value: 'millimeter', label: 'Millimeters' },
    { value: 'mile', label: 'Miles' },
    { value: 'yard', label: 'Yards' },
    { value: 'foot', label: 'Feet' },
    { value: 'inch', label: 'Inches' },
    { value: 'nm', label: 'Nanometers' },
    { value: 'um', label: 'Micrometers' },
    { value: 'dm', label: 'Decimeters' },
    { value: 'in', label: 'Inches' },
    { value: 'ft', label: 'Feet' },
    { value: 'yd', label: 'Yards' },
    { value: 'mi', label: 'Miles' },
    { value: 'nmi', label: 'Nautical Miles' },
    { value: 'ly', label: 'Light Years' },
    { value: 'au', label: 'Astronomical Units' },
    { value: 'parsec', label: 'Parsecs' }
  ],
  weight: [
    { value: 'ug', label: 'Micrograms' },
    { value: 'mg', label: 'Milligrams' },
    { value: 'cg', label: 'Centigrams' },
    { value: 'dg', label: 'Decigrams' },
    { value: 'g', label: 'Grams' },
    { value: 'kg', label: 'Kilograms' },
    { value: 'mt', label: 'Metric Tons' },
    { value: 'oz', label: 'Ounces' },
    { value: 'dr', label: 'Drams' },
    { value: 'lb', label: 'Pounds' },
    { value: 'st', label: 'Stone' },
    { value: 'cwt', label: 'Hundredweight' },
    { value: 'ton_us', label: 'US Tons' },
    { value: 'ton_uk', label: 'UK Tons' }
  ],
  temperature: [
    { value: 'celsius', label: 'Celsius' },
    { value: 'fahrenheit', label: 'Fahrenheit' },
    { value: 'kelvin', label: 'Kelvin' },
    { value: 'rankine', label: 'Rankine' },
    { value: 'reaumur', label: 'Réaumur' },
    { value: 'delisle', label: 'Delisle' }
  ],
  cooking: [
    { value: 'ul', label: 'Microliters' },
    { value: 'ml', label: 'Milliliters' },
    { value: 'cl', label: 'Centiliters' },
    { value: 'dl', label: 'Deciliters' },
    { value: 'l', label: 'Liters' },
    { value: 'dash', label: 'Dash' },
    { value: 'pinch', label: 'Pinch' },
    { value: 'tsp', label: 'Teaspoons' },
    { value: 'tbsp', label: 'Tablespoons' },
    { value: 'fl_oz', label: 'Fluid Ounces' },
    { value: 'cup', label: 'Cups' },
    { value: 'pt', label: 'Pints' },
    { value: 'qt', label: 'Quarts' },
    { value: 'gal', label: 'Gallons' },
    { value: 'bbl', label: 'Barrels' }
  ],
  dev: [
    { value: 'px', label: 'Pixels' },
    { value: 'rem', label: 'REM' },
    { value: 'em', label: 'EM' },
    { value: 'pt', label: 'Points' },
    { value: 'pc', label: 'Picas' },
    { value: 'percent', label: 'Percentage' },
    { value: 'vw', label: 'Viewport Width' },
    { value: 'vh', label: 'Viewport Height' },
    { value: 'vmin', label: 'Viewport Min' },
    { value: 'vmax', label: 'Viewport Max' },
    { value: 'ch', label: 'Character Width' },
    { value: 'ex', label: 'X-Height' }
  ],
  time: [
    { value: 'ns', label: 'Nanoseconds' },
    { value: 'us', label: 'Microseconds' },
    { value: 'ms', label: 'Milliseconds' },
    { value: 's', label: 'Seconds' },
    { value: 'min', label: 'Minutes' },
    { value: 'h', label: 'Hours' },
    { value: 'd', label: 'Days' },
    { value: 'w', label: 'Weeks' },
    { value: 'fortnight', label: 'Fortnights' },
    { value: 'mo', label: 'Months' },
    { value: 'y', label: 'Years' },
    { value: 'decade', label: 'Decades' },
    { value: 'century', label: 'Centuries' },
    { value: 'millennium', label: 'Millennia' }
  ],
  data: [
    { value: 'bit', label: 'Bits' },
    { value: 'nibble', label: 'Nibbles' },
    { value: 'byte', label: 'Bytes' },
    { value: 'word', label: 'Words' },
    { value: 'kb', label: 'Kilobytes' },
    { value: 'mb', label: 'Megabytes' },
    { value: 'gb', label: 'Gigabytes' },
    { value: 'tb', label: 'Terabytes' },
    { value: 'pb', label: 'Petabytes' },
    { value: 'eb', label: 'Exabytes' },
    { value: 'zb', label: 'Zettabytes' },
    { value: 'yb', label: 'Yottabytes' }
  ],
  energy: [
    { value: 'j', label: 'Joules' },
    { value: 'kj', label: 'Kilojoules' },
    { value: 'mj', label: 'Megajoules' },
    { value: 'cal', label: 'Calories' },
    { value: 'kcal', label: 'Kilocalories' },
    { value: 'wh', label: 'Watt-hours' },
    { value: 'kwh', label: 'Kilowatt-hours' },
    { value: 'mwh', label: 'Megawatt-hours' },
    { value: 'btu', label: 'BTU' },
    { value: 'therm', label: 'Therms' },
    { value: 'ft_lb', label: 'Foot-pounds' },
    { value: 'ev', label: 'Electron Volts' }
  ],
  pressure: [
    { value: 'pa', label: 'Pascal' },
    { value: 'kpa', label: 'Kilopascal' },
    { value: 'mpa', label: 'Megapascal' },
    { value: 'bar', label: 'Bar' },
    { value: 'psi', label: 'PSI' },
    { value: 'atm', label: 'Atmosphere' },
    { value: 'mmhg', label: 'mmHg' },
    { value: 'inhg', label: 'inHg' },
    { value: 'torr', label: 'Torr' },
    { value: 'hpa', label: 'Hectopascal' }
  ],
  speed: [
    { value: 'mps', label: 'Meters/Second' },
    { value: 'kph', label: 'Kilometers/Hour' },
    { value: 'mph', label: 'Miles/Hour' },
    { value: 'fps', label: 'Feet/Second' },
    { value: 'knot', label: 'Knots' },
    { value: 'mach', label: 'Mach' },
    { value: 'c', label: 'Speed of Light' },
    { value: 'kmh', label: 'Kilometers/Hour' },
    { value: 'fpm', label: 'Feet/Minute' }
  ],
  angle: [
    { value: 'deg', label: 'Degrees' },
    { value: 'rad', label: 'Radians' },
    { value: 'grad', label: 'Gradians' },
    { value: 'arcmin', label: 'Arc Minutes' },
    { value: 'arcsec', label: 'Arc Seconds' },
    { value: 'turn', label: 'Turns' },
    { value: 'mil', label: 'Mil' },
    { value: 'circle', label: 'Circle' }
  ],
  frequency: [
    { value: 'hz', label: 'Hertz' },
    { value: 'khz', label: 'Kilohertz' },
    { value: 'mhz', label: 'Megahertz' },
    { value: 'ghz', label: 'Gigahertz' },
    { value: 'rpm', label: 'RPM' },
    { value: 'bpm', label: 'BPM' },
    { value: 'thz', label: 'Terahertz' },
    { value: 'cps', label: 'Cycles per Second' },
    { value: 'rps', label: 'Revolutions per Second' }
  ],
  fuel: [
    { value: 'mpg_us', label: 'Miles/Gallon (US)' },
    { value: 'mpg_uk', label: 'Miles/Gallon (UK)' },
    { value: 'lp100km', label: 'L/100km' },
    { value: 'kml', label: 'Kilometers/Liter' },
    { value: 'gpm', label: 'Gallons/Mile' },
    { value: 'lpk', label: 'Liters/Kilometer' },
    { value: 'mpk', label: 'Miles/Kilometer' }
  ],
  typography: [
    { value: 'pt', label: 'Points' },
    { value: 'pc', label: 'Picas' },
    { value: 'px', label: 'Pixels' },
    { value: 'in_type', label: 'Inches' },
    { value: 'mm_type', label: 'Millimeters' },
    { value: 'q', label: 'Quarter-millimeters' },
    { value: 'twips', label: 'Twips' },
    { value: 'dtp', label: 'DTP Points' }
  ],
  photography: [
    { value: 'ev', label: 'EV' },
    { value: 'iso', label: 'ISO' },
    { value: 'fstop', label: 'f-Stop' },
    { value: 'fl', label: 'Focal Length' },
    { value: 'lv', label: 'Light Value' },
    { value: 'tc', label: 'T-Stop' },
    { value: 'dof', label: 'Depth of Field' },
    { value: 'coc', label: 'Circle of Confusion' }
  ],
  torque: [
    { value: 'nm', label: 'Newton Meters' },
    { value: 'ftlb', label: 'Foot Pounds' },
    { value: 'kgfm', label: 'Kilogram Force Meters' },
    { value: 'inlb', label: 'Inch Pounds' },
    { value: 'ozin', label: 'Ounce Inches' },
    { value: 'dyn_cm', label: 'Dyne Centimeters' },
    { value: 'joule_rad', label: 'Joules/Radian' }
  ],
  radiation: [
    { value: 'sv', label: 'Sievert' },
    { value: 'msv', label: 'Millisievert' },
    { value: 'usv', label: 'Microsievert' },
    { value: 'rem', label: 'Rem' },
    { value: 'rad', label: 'Rad' },
    { value: 'gy', label: 'Gray' }
  ],
  density: [
    { value: 'kgm3', label: 'kg/m³' },
    { value: 'gcm3', label: 'g/cm³' },
    { value: 'lbft3', label: 'lb/ft³' },
    { value: 'ozin3', label: 'oz/in³' },
    { value: 'slugft3', label: 'slug/ft³' },
    { value: 'lbyd3', label: 'lb/yd³' },
    { value: 'mgml', label: 'mg/mL' }
  ],
  flow: [
    { value: 'm3s', label: 'm³/s' },
    { value: 'lps', label: 'L/s' },
    { value: 'cfm', label: 'CFM' },
    { value: 'gpm', label: 'GPM' },
    { value: 'lpm', label: 'L/min' },
    { value: 'cfs', label: 'ft³/s' },
    { value: 'gph', label: 'Gallons/Hour' },
    { value: 'afh', label: 'Acre-feet/Hour' }
  ],
  sound: [
    { value: 'db', label: 'Decibels' },
    { value: 'dba', label: 'dBA' },
    { value: 'dbspl', label: 'dB SPL' },
    { value: 'phon', label: 'Phon' },
    { value: 'sone', label: 'Sone' },
    { value: 'dbhl', label: 'dB HL' },
    { value: 'dbw', label: 'dB(W)' },
    { value: 'dbm', label: 'dBm' },
    { value: 'db_spl', label: 'Decibel SPL (dB)' },
    { value: 'db_a', label: 'A-weighted dB (dBA)' },
    { value: 'db_c', label: 'C-weighted dB (dBC)' },
    { value: 'db_w', label: 'Sound Power (dBW)' },
    { value: 'w_m2', label: 'Watts/m²' },
    { value: 'pa', label: 'Pascal (Pa)' },
    { value: 'phon', label: 'Phon' },
    { value: 'sone', label: 'Sone' }
  ],
  textile: [
    { value: 'denier', label: 'Denier' },
    { value: 'tex', label: 'Tex' },
    { value: 'dtex', label: 'Decitex' },
    { value: 'jute', label: 'Jute Count' },
    { value: 'cotton', label: 'Cotton Count' },
    { value: 'worsted', label: 'Worsted Count' }
  ],
  astronomy: [
    { value: 'au', label: 'Astronomical Units' },
    { value: 'ly', label: 'Light Years' },
    { value: 'pc', label: 'Parsecs' },
    { value: 'kpc', label: 'Kiloparsecs' },
    { value: 'mpc', label: 'Megaparsecs' }
  ],
  surveying: [
    { value: 'chain', label: 'Chains' },
    { value: 'rod', label: 'Rods' },
    { value: 'link', label: 'Links' },
    { value: 'furlong', label: 'Furlongs' },
    { value: 'acre', label: 'Acres' },
    { value: 'hectare', label: 'Hectares' }
  ],
  viscosity: [
    { value: 'poise', label: 'Poise' },
    { value: 'stokes', label: 'Stokes' },
    { value: 'pas', label: 'Pascal-seconds' },
    { value: 'cst', label: 'Centistokes' },
    { value: 'mpa_s', label: 'Millipascal-seconds' },
    { value: 'nsm2', label: 'Newton-seconds/m²' },
    { value: 'reyn', label: 'Reyn' },
    { value: 'saybolt', label: 'Saybolt Universal Seconds' }
  ],
  magnetic: [
    { value: 'tesla', label: 'Tesla' },
    { value: 'gauss', label: 'Gauss' },
    { value: 'weber', label: 'Weber' },
    { value: 'maxwell', label: 'Maxwell' },
    { value: 'mx', label: 'Maxwells' },
    { value: 'unit_pole', label: 'Unit Pole' },
    { value: 'gamma', label: 'Gamma' },
    { value: 'emu', label: 'EMU' }
  ],
  lumber: [
    { value: 'fbm', label: 'Board Feet' },
    { value: 'cord', label: 'Cords' },
    { value: 'ccf', label: 'Hundred Cubic Feet' },
    { value: 'mbf', label: 'Thousand Board Feet' },
    { value: 'cunits', label: 'Cunits' },
    { value: 'tons', label: 'Tons' },
    { value: 'loads', label: 'Loads' },
    { value: 'stacks', label: 'Stacks' }
  ],
  gardening: [
    { value: 'seed_oz', label: 'Seeds per Ounce' },
    { value: 'plant_density', label: 'Plants per Acre' },
    { value: 'spacing_ft', label: 'Plant Spacing (ft)' },
    { value: 'yield_acre', label: 'Yield per Acre' },
    { value: 'row_spacing', label: 'Row Spacing' },
    { value: 'germination', label: 'Germination Rate' },
    { value: 'growth_rate', label: 'Growth Rate' },
    { value: 'water_rate', label: 'Water Rate' }
  ],
  brewing: [
    { value: 'sg', label: 'Specific Gravity' },
    { value: 'plato', label: 'Plato (°P)' },
    { value: 'brix', label: 'Brix (°Bx)' },
    { value: 'srm', label: 'SRM' },
    { value: 'ebc', label: 'EBC' },
    { value: 'lovibond', label: 'Lovibond (°L)' },
    { value: 'ibu', label: 'IBU' },
    { value: 'abv', label: 'ABV %' },
    { value: 'abw', label: 'ABW %' }
  ],
  shoe: [
    { value: 'us_men', label: 'US Men' },
    { value: 'us_women', label: 'US Women' },
    { value: 'uk', label: 'UK' },
    { value: 'eu', label: 'EU' },
    { value: 'mondopoint', label: 'Mondopoint' },
    { value: 'cm', label: 'Centimeters' }
  ],
  maritime: [
    { value: 'fathom', label: 'Fathoms' },
    { value: 'cable', label: 'Cables' },
    { value: 'nmile', label: 'Nautical Miles' },
    { value: 'league', label: 'Leagues' },
    { value: 'beaufort', label: 'Beaufort Scale' }
  ],
  music: [
    { value: 'bpm', label: 'Beats per Minute' },
    { value: 'cents', label: 'Cents (pitch)' },
    { value: 'semitones', label: 'Semitones' },
    { value: 'octaves', label: 'Octaves' },
    { value: 'hz_music', label: 'Frequency (Hz)' }
  ],
  sports: [
    { value: 'pace', label: 'Pace (min/km)' },
    { value: 'vo2max', label: 'VO2 Max' },
    { value: 'met', label: 'Metabolic Equivalent' },
    { value: 'power', label: 'Power (watts)' },
    { value: 'cadence', label: 'Cadence (rpm)' }
  ],
  art: [
    { value: 'golden_ratio', label: 'Golden Ratio' },
    { value: 'canvas', label: 'Canvas Sizes' },
    { value: 'dpi', label: 'DPI/PPI' },
    { value: 'aspect_ratio', label: 'Aspect Ratio' },
    { value: 'color_space', label: 'Color Space Values' }
  ],
  gaming: [
    { value: 'dps', label: 'Damage per Second' },
    { value: 'fps_game', label: 'Frames per Second' },
    { value: 'tick_rate', label: 'Server Tick Rate' },
    { value: 'sensitivity', label: 'Mouse Sensitivity' },
    { value: 'ping', label: 'Latency (ms)' }
  ],
  finance: [
    { value: 'crypto', label: 'Cryptocurrency Units' },
    { value: 'leverage', label: 'Leverage Ratios' },
    { value: 'interest', label: 'Interest Rate Types' },
    { value: 'volatility', label: 'Volatility Measures' },
    { value: 'margin', label: 'Margin Requirements' }
  ],
  geology: [
    { value: 'mohs', label: 'Mohs Hardness' },
    { value: 'richter', label: 'Richter Scale' },
    { value: 'geological_time', label: 'Geological Time' },
    { value: 'mineral_grade', label: 'Mineral Grades' },
    { value: 'porosity', label: 'Porosity' }
  ],
  chemistry: [
    { value: 'molarity', label: 'Molarity' },
    { value: 'ph', label: 'pH Scale' },
    { value: 'concentration', label: 'Concentration' },
    { value: 'redox', label: 'Redox Potential' },
    { value: 'atomic_mass', label: 'Atomic Mass Units' }
  ],
  weather: [
    { value: 'beaufort', label: 'Beaufort Scale' },
    { value: 'uv_index', label: 'UV Index' },
    { value: 'air_quality', label: 'Air Quality Index' },
    { value: 'visibility', label: 'Visibility Range' },
    { value: 'cloud_cover', label: 'Cloud Cover' }
  ],
  construction: [
    { value: 'concrete_grade', label: 'Concrete Grades' },
    { value: 'rebar_size', label: 'Rebar Sizes' },
    { value: 'slope', label: 'Slope/Grade' },
    { value: 'insulation', label: 'Insulation Values' },
    { value: 'load_bearing', label: 'Load Bearing' }
  ],
  printing: [
    { value: 'paper_weight', label: 'Paper Weight' },
    { value: 'line_screen', label: 'Line Screen' },
    { value: 'dot_gain', label: 'Dot Gain' },
    { value: 'bleed', label: 'Bleed Margins' },
    { value: 'opacity', label: 'Opacity' }
  ],
  electronics: [
    { value: 'volt', label: 'Volt (V)' },
    { value: 'kilovolt', label: 'Kilovolt (kV)' },
    { value: 'millivolt', label: 'Millivolt (mV)' },
    { value: 'microvolt', label: 'Microvolt (µV)' },
    { value: 'ampere', label: 'Ampere (A)' },
    { value: 'milliamp', label: 'Milliamp (mA)' },
    { value: 'microamp', label: 'Microamp (µA)' },
    { value: 'kiloamp', label: 'Kiloamp (kA)' },
    { value: 'ohm', label: 'Ohms' },
    { value: 'watt', label: 'Watts' },
    { value: 'farad', label: 'Farads' },
    { value: 'henry', label: 'Henries' },
    { value: 'coulomb', label: 'Coulombs' },
    { value: 'siemens', label: 'Siemens' }
  ],
  nuclear: [
    { value: 'becquerel', label: 'Becquerel' },
    { value: 'curie', label: 'Curie' },
    { value: 'rutherford', label: 'Rutherford' },
    { value: 'roentgen', label: 'Roentgen' },
    { value: 'gray', label: 'Gray' },
    { value: 'rad_nuclear', label: 'Rad' }
  ],
  quantum: [
    { value: 'planck_length', label: 'Planck Length' },
    { value: 'planck_mass', label: 'Planck Mass' },
    { value: 'planck_time', label: 'Planck Time' },
    { value: 'planck_temperature', label: 'Planck Temperature' },
    { value: 'planck_energy', label: 'Planck Energy' }
  ],
  optics: [
    { value: 'lumen', label: 'Lumens' },
    { value: 'lux', label: 'Lux' },
    { value: 'candela', label: 'Candela' },
    { value: 'nit', label: 'Nits' },
    { value: 'lambert', label: 'Lamberts' }
  ],
  acoustics: [
    { value: 'spl', label: 'Sound Pressure Level' },
    { value: 'sil', label: 'Sound Intensity Level' },
    { value: 'sonority', label: 'Sonority' },
    { value: 'phon_acoustic', label: 'Phon' },
    { value: 'sone', label: 'Sone' }
  ],
  magnetism: [
    { value: 'tesla_mag', label: 'Tesla' },
    { value: 'gauss_mag', label: 'Gauss' },
    { value: 'oersted', label: 'Oersted' },
    { value: 'maxwell_mag', label: 'Maxwell' },
    { value: 'weber_mag', label: 'Weber' }
  ],
  cosmology: [
    { value: 'hubble', label: 'Hubble Units' },
    { value: 'solar_mass', label: 'Solar Masses' },
    { value: 'redshift', label: 'Redshift' },
    { value: 'cosmic_year', label: 'Cosmic Years' },
    { value: 'parsec_cosmo', label: 'Parsecs' }
  ],
  biology: [
    { value: 'metabolic_rate', label: 'Metabolic Rate' },
    { value: 'blood_glucose', label: 'Blood Glucose' },
    { value: 'enzyme_activity', label: 'Enzyme Activity' },
    { value: 'cell_count', label: 'Cell Count' },
    { value: 'osmolarity', label: 'Osmolarity' }
  ],
  networking: [
    { value: 'bandwidth', label: 'Bandwidth' },
    { value: 'latency', label: 'Latency' },
    { value: 'packet_loss', label: 'Packet Loss' },
    { value: 'throughput', label: 'Throughput' },
    { value: 'jitter', label: 'Jitter' }
  ],
  digital_storage: [
    { value: 'sector', label: 'Disk Sectors' },
    { value: 'cluster', label: 'Disk Clusters' },
    { value: 'block', label: 'Disk Blocks' },
    { value: 'page', label: 'Memory Pages' },
    { value: 'inode', label: 'Inodes' }
  ],
  computer_memory: [
    { value: 'register', label: 'CPU Registers' },
    { value: 'cache_line', label: 'Cache Lines' },
    { value: 'stack_frame', label: 'Stack Frames' },
    { value: 'heap_block', label: 'Heap Blocks' },
    { value: 'virtual_page', label: 'Virtual Pages' }
  ],
  resolution: [
    { value: 'mpx', label: 'Megapixels' },
    { value: 'ppi', label: 'Pixels per Inch' },
    { value: 'dpcm', label: 'Dots per CM' },
    { value: 'lpi', label: 'Lines per Inch' },
    { value: 'k_resolution', label: '4K/8K Resolution' }
  ],
  color: [
    { value: 'rgb', label: 'RGB Values' },
    { value: 'cmyk', label: 'CMYK Values' },
    { value: 'hsv', label: 'HSV Values' },
    { value: 'lab', label: 'LAB Values' },
    { value: 'pantone', label: 'Pantone Colors' }
  ],
  'ai-ml': [
    { value: 'flops', label: 'FLOPS' },
    { value: 'gflops', label: 'GFLOPS' },
    { value: 'tflops', label: 'TFLOPS' },
    { value: 'pflops', label: 'PFLOPS' },
    { value: 'parameters', label: 'Parameters' },
    { value: 'parameters_b', label: 'Billion Parameters' },
    { value: 'model_mb', label: 'Model Size (MB)' },
    { value: 'model_gb', label: 'Model Size (GB)' },
    { value: 'vram_gb', label: 'VRAM (GB)' },
    { value: 'inference_ms', label: 'Inference Time (ms)' },
    { value: 'inference_fps', label: 'Inference FPS' },
    { value: 'tokens_s', label: 'Tokens/Second' }
  ]
};
